import { type CloudFlowNodeType } from "@doitintl/cmp-models";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import { Card, Stack } from "@mui/material";

import { cloudflowTexts } from "../../../../../assets/texts";
import ConditionForm from "../../FilterAction/ConditionForm";
import FieldReferenceForm from "../../FilterAction/FieldReferenceForm";
import SwitchDataSourceDialog from "../../FilterAction/SwitchDataSourceDialog";
import { useNodeDataSourceUpdate } from "../hooks";
import { useNodeConfigurationContext } from "../NodeConfigurationContext";
import { NodeCardHeader } from "./NodeCardHeader";

const FilterParametersTab = () => {
  const { nodeConfig } = useNodeConfigurationContext<CloudFlowNodeType.FILTER>();

  const {
    selectedNode,
    setSelectedNode,
    referenceableNodes,
    switchDataSourceOpen,
    handleConfirm,
    handleClose,
    confirmSwitchDataSource,
  } = useNodeDataSourceUpdate({
    nodeId: nodeConfig.id,
    referencedNodeId: nodeConfig.parameters.referencedNodeId,
  });

  return (
    <Stack
      sx={{
        px: 2,
        justifyContent: "center",
        gap: 2,
        mt: 1,
      }}
    >
      <Card>
        <NodeCardHeader
          avatar={<FilterAltIcon color="primary" />}
          subheader={cloudflowTexts.FILTER_PANEL_SUBTITLE}
          title={cloudflowTexts.FILTER_TITLE}
        />
      </Card>
      <FieldReferenceForm
        selectedNode={selectedNode}
        confirmSwitchDataSource={confirmSwitchDataSource}
        referenceableNodes={referenceableNodes}
        setSelectedNode={setSelectedNode}
        texts={{
          referenceField: {
            title: cloudflowTexts.SELECT_FIELD_TO_FILTER,
            subtitle: cloudflowTexts.DATA_WILL_BE_PASSED_DOWN_THE_FLOW,
          },
        }}
      />
      <ConditionForm
        selectedNode={selectedNode}
        referenceableNodes={referenceableNodes}
        texts={{
          addNewGroupText: cloudflowTexts.ADD_NEW_FILTER_GROUP,
          defineCriteriaText: cloudflowTexts.DEFINE_FILTER_CRITERIA,
          fromChosenFieldText: cloudflowTexts.DEFINE_FILTER_CRITERIA_FROM_DATA_SOURCE,
          groupText: cloudflowTexts.FILTER_TITLE,
          addNewText: cloudflowTexts.ADD_NEW_FILTER,
        }}
      />
      <SwitchDataSourceDialog
        isDialogOpened={switchDataSourceOpen}
        handleClose={handleClose}
        handleConfirm={handleConfirm}
      />
    </Stack>
  );
};

export default FilterParametersTab;
